<template>
  <div>
    <h3>Brand Visual</h3>
    <div class="h4 py-5">顯示於首頁置頂區域</div>
    <div class="form-item d-flex py-5">
      <h4 class="w-174px mr-6px">Title</h4>
      <div class="h4">
        (Innovating the future 為圖檔，在後台不提供更改)
      </div>
    </div>
    <div class="form-item d-flex py-5">
      <h4 class="w-174px mr-6px">Background</h4>
      <div class="h4">
        (圖檔有微動態設定，因此在後台不提供更改)
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'homepage',
  ],
};
</script>

<style></style>
